import React from 'react';

import BudgetReportStratProj from './BudgetReportsViews/BudgetReportStratProj';
import BudgetReportProj from './BudgetReportsViews/BudgetReportProj';

// Возвращает нужное представление (страт.проект / проект) и применяет ролевую модель
export default function BudgetReportsTab({
  stratId, projectId, portfolioId, originId, strategyNum, projectNum, strategyType,
}) {
  if (projectId) {
    return <BudgetReportProj strategyId={stratId} projectId={projectId} originId={originId} num={projectNum} strategyType={strategyType} />;
  } else if (portfolioId) {
    return <BudgetReportStratProj portfolioId={portfolioId} strategyType={strategyType} />;
  } else {
    return <BudgetReportStratProj strategyId={stratId} projectId={projectId} originId={originId} num={strategyNum} strategyType={strategyType} />;
  }
}
